/* istanbul ignore file */

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { AppDispatch, RootState } from 'redux/store';
import { useValidations } from './validations';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
const useAppDispatch: AppDispatch = useDispatch;

export {
  useAppSelector,
  useAppDispatch,
  useValidations,
};
